export const POPUP_PRESENTS_ID = 'sb-popup-cart-presents'
